























import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import KintaiPatternForm from '../organisms/KintaiPatternForm.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'

@Component({
  components: { TcwLayoutBasicTemplate, KintaiPatternForm }
})
export default class KintaiPatternPage extends Mixins(BasePage) {
  private get patternId(): string | null {
    if (this.routeParams['patternId']) {
      return this.routeParams['patternId']
    } else {
      return null
    }
  }
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected save(): void {
    this.form.startSaveProc()
  }
}
